import { createStore, combineReducers, applyMiddleware, compose } from "redux";
import { thunk } from "redux-thunk";
import { funnelReducers } from "./funnelReducers";
import actionItemsReducer from "./ducks/actionItems";
import layoutReducer from "./ducks/layout";
import communitiesReducer from "./ducks/communities";
import supportReducer from "./ducks/support";
import automationsReducer from "./ducks/automations";

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
const rootReducer = combineReducers({
    ...funnelReducers,
    actionItemsState: actionItemsReducer,
    layoutState: layoutReducer,
    communitiesState: communitiesReducer,
    supportState: supportReducer,
    automationsState: automationsReducer
});
const enhancer = composeEnhancers(applyMiddleware(thunk));

const store = createStore(rootReducer, enhancer);

export default store;